import AutoCompleteBruger from "@/components/autocomplete/AutoCompleteBruger";
import { AccordionFilterItem } from "@/components/accordion/Accordion";
import AppliedFilterItem from "@/components/filter/AppliedFilterItem";
import InputCheckbox from "@/components/formcontrols/InputCheckbox";

export interface ReviewThreadAssignment {
  assignedTo?: boolean;
  /** Kollegaens e-mail; CLE-API'et udleder selv admin-id'et den er gemt under. */
  assignedAdminEmail?: string;
  assignedAdminDisplayName?: string;
}

interface ReviewThreadAssignmentFilterProps extends ReviewThreadAssignment {
  onAssignmentChange: (assignment: ReviewThreadAssignment) => void;
}

export default function ReviewThreadAssignmentFilter({
  assignedTo,
  assignedAdminEmail,
  assignedAdminDisplayName,
  onAssignmentChange,
}: ReviewThreadAssignmentFilterProps) {
  const isActive = !!assignedTo || !!assignedAdminEmail;

  const clearAssignment = () => {
    onAssignmentChange({});
  };

  const handleAssignedToMeChange = (checked: boolean) => {
    onAssignmentChange(checked ? { assignedTo: true } : {});
  };

  const handleAdminChange = (admin: { email: string; navn: string }) => {
    onAssignmentChange({
      assignedAdminEmail: admin.email,
      assignedAdminDisplayName: admin.navn,
    });
  };

  return (
    <AccordionFilterItem
      title="Tildeling"
      value="review-thread-assignment"
      isActive={isActive}
    >
      {isActive ? (
        <div className="c-applied-filter-group mb-3">
          {assignedTo ? (
            <AppliedFilterItem
              label="Kun mine"
              removeFilterHandler={clearAssignment}
            />
          ) : null}
          {assignedAdminEmail && assignedAdminDisplayName ? (
            <AppliedFilterItem
              label={assignedAdminDisplayName}
              removeFilterHandler={clearAssignment}
            />
          ) : null}
        </div>
      ) : null}

      <div className="mb-3">
        <InputCheckbox
          id="review-thread-assignment-me"
          label="Kun mine"
          checked={!!assignedTo && !assignedAdminEmail}
          onChange={(event) => handleAssignedToMeChange(event.target.checked)}
        />
      </div>

      <p className="text-muted small mb-2">Eller søg efter medarbejder</p>
      <AutoCompleteBruger
        clearAfterSelection
        placeholder="Søg på navn eller e-mail ..."
        onSelectedItemChange={handleAdminChange}
      />
    </AccordionFilterItem>
  );
}
